import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loading from "../../../components/misc/Loading";
import useProcessedProducts from "./useProcessedProducts";
import FarmProcessedProductDetails from "./FarmProcessedProductDetails";
import "./farmProductPage.css";

export default function FarmProcessedProductPage() {
  const { productId } = useParams();
  const language = useSelector((state) => state.app.language);
  const sv = language === 0;
  const { products, loading, error, retry } = useProcessedProducts(productId);
  const product = products.find((item) => item.firebaseId === productId);

  useEffect(() => { window.scrollTo(0, 0); }, [productId]);

  if (product) return <FarmProcessedProductDetails key={product.firebaseId} product={product} language={language} />;
  if (loading) return <main className="AppLoading" role="status" aria-label={sv ? "Laddar produkt" : "Loading product"} aria-busy="true"><Loading /></main>;
  return <main className="ProductDetail ProductDetailState">
    <Link to="/farm" className="ProductWordmark">VERT<span>.farm</span></Link>
    <div role={error ? "alert" : "status"}>
      <p className="ProductEyebrow">{sv ? "PROCESSADE PRODUKTER" : "PROCESSED PRODUCTS"}</p>
      <h1>{error ? (sv ? "Vi kunde inte hämta produkten." : "We couldn't load this product.") : (sv ? "Produkten hittades inte." : "Product not found.")}</h1>
      {error && <button className="ProductButton" type="button" onClick={retry}>{sv ? "Försök igen" : "Try again"}</button>}
    </div>
    <Link className="ProductTextLink" to="/farm/products/processed">{sv ? "Till processade produkter" : "Back to processed products"} →</Link>
  </main>;
}
